import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { OnlyBackButton } from '../../../components/base/BottomStepComponent';
import ContentSections from '../../../components/base/ContentSections';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import MembershipInfoCard from '../../../components/customer/MembershipInfoCard';
import { getRecordsRelatedTransactionCard } from '../pointRecords/PointTransactionOverview';
import { recordType } from '../../../models/StampRecordModel';
import { createAction } from 'utils';

function StampRecordDetail({ stampRecord }) {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'stampRecord/getOneDetail',
      payload: {
        id: params.id,
      },
    });
    return () => dispatch(createAction("stampRecord/clearData")())
  }, [dispatch, params.id]);

  const getStampDetailSectionFieldsWithType = (recordType) => {
    let extraFields = [];
    if (recordType === 'STAMP_EXPIRED') {
      extraFields = extraFields.concat([
        [{ title: 'Expiry date', field: 'createDate' }],
      ]);
    }
    return [
      [{ title: 'Quantity', field: 'quantity' }],
      [{ title: 'Remarks (optional)', field: 'remark' }],
      ...extraFields,
    ];
  };

  const tabs = [
    {
      name: '',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={[
              <MembershipInfoCard
                title={'STAMP RECORD DETAILS'}
                data={stampRecord}
                fields={[
                    [{ title:'Customer', field:'name', customerLink: true }],
                    [{ title: 'Membership ID', field: 'membershipId' }],
                    [{title:'Event Type', field:'displayEventType'}],
                    [{title:'Record Type', field:'displayRecordType'}],
                  ].concat(
                    [
                      recordType.ADMIN_REMOVE,
                      recordType.ADMIN_ADD,
                      recordType.MERCHANT_REMOVE,
                      recordType.MERCHANT_ADD,
                    ].includes(stampRecord?.displayRecordType)
                      ? [
                          [
                            {
                              title: 'Admin User',
                              field: 'displayAdministrator',
                            },
                          ],
                        ]
                      : [],
                  )}
              />,
              <MembershipInfoCard
                title={stampRecord.displayEventType}
                data={stampRecord}
                fields={getStampDetailSectionFieldsWithType(
                  stampRecord.recordType,
                )}
              />,
              ...(stampRecord?.transaction?.pk ? [
                getRecordsRelatedTransactionCard(stampRecord.transaction)
              ] : []),
              ...stampRecord?.reachLimit ?
                [<MembershipInfoCard
                  title="Reward limit reached"
                  data={stampRecord.reachLimitInfo}
                  fields={[
                    [{ title: 'Limit', field: 'displayLimit' }],
                    [{ title: 'Maximum reward limit', field: 'displayMaximumRewardLimit' }],
                    [{ title: 'Accumulated reward', field: 'displayAccumulatedReward' }],
                    [{ title: 'Original reward from this record', field: 'displayOriginalReward' }],
                    [{ title: 'Final reward', field: 'displayFinalReward' }],
                  ]}
                />] : [],
              <MembershipInfoCard
                title={'GENERAL'}
                data={stampRecord}
                fields={[
                  [{ title: 'Purchase date', field: 'detailDisplayPurchaseDate' }],
                  [{ title: 'Creation date', field: 'detailDisplayCreationDate' }],
                ]}
              />,
            ]}
            hidePreview={true}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <CustomListComponent 
      caution={{
        detail:'',
        title:'Stamp record details'
      }}
      breadcrumb={<CustomBreadcrumb />} 
      hideTab={true}
      tabs={tabs}
      buttons={[]}
      />
      <OnlyBackButton
        backAction={() => {
          history.push({
            pathname: '/stamp_records',
          });
        }}
      />
    </>
  );
}
const mapPropsToState = (state) => ({
  stampRecord: state.stampRecord.detail,
});

export default connect(mapPropsToState)(StampRecordDetail);
